export const bytesToHex = bytes =>
  [...bytes].map(x => x.toString(16).padStart(2, "0")).join("")

export const consoleLog = (...args) => __DEV__ && console.log(...args)

export const consoleError = (...args) => __DEV__ && console.error(...args)
